import { TFunction } from 'client/i18n/hooks/useT';

export const getStatusHeading = (
  t: TFunction,
  isProcessing?: boolean,
  isError?: boolean,
  percentageComplete?: number
) => {
  if (isProcessing) {
    if (isError) {
      return t(
        'EpisodeOptionsScreen.EpisodeContent.UploadingState.ProcessingFailedHeader',
        'Processing failed',
        'Processing audio failed header'
      );
    }
    return t(
      'EpisodeOptionsScreen.EpisodeContent.UploadingState.ProcessingHeader',
      'Processing...',
      'Processing audio header'
    );
  }
  if (isError) {
    return t(
      'EpisodeOptionsScreen.EpisodeContent.UploadingState.UploadFailedHeader',
      'Upload failed',
      'Upload audio failed header'
    );
  }
  if (percentageComplete === 100) {
    return t(
      'EpisodeOptionsScreen.EpisodeContent.UploadingState.UploadedHeader',
      'Uploaded!',
      'Uploaded audio header'
    );
  }
  return t(
    'EpisodeOptionsScreen.EpisodeContent.UploadingState.UploadingHeader',
    'Uploading...',
    'Uploading audio header'
  );
};

export const getStatusLabel = (
  t: TFunction,
  isProcessing?: boolean,
  isError?: boolean,
  percentageComplete?: number
) => {
  if (isProcessing) {
    if (isError) {
      return t(
        'EpisodeOptionsScreen.EpisodeContent.UploadingState.StartOverStatusLabel',
        'Hit “cancel” to start over.',
        'Upload audio tool status label'
      );
    }
    return t(
      'EpisodeOptionsScreen.EpisodeContent.UploadingState.PreviewReadySoonStatusLabel',
      'An audio preview will be ready soon',
      'Upload audio tool status label'
    );
  }
  if (isError) {
    return t(
      'EpisodeOptionsScreen.EpisodeContent.UploadingState.UploadRetryStatusLabel',
      'Hit “retry” to try again.',
      'Upload audio tool status label'
    );
  }
  return `${percentageComplete}%`;
};
